module.exports = __webpack_public_path__ + "images/e9a7320ed8743f86eaede6b8f9b336c2.jpg";